<template>
  <site-banner :titulo="tratamento.nome" imagem="tratamento-banner" />

  <div class="container sessao">
    <div class="row">
      <!-- <div class="col-md-7"> -->
        <h2 class="mb-5">Sobre {{ tratamento.nome }}</h2>
        <p class="mx-5">{{ tratamento.descricao }}</p>
      <!-- </div> -->
      <!-- <div class="col-md-5">
        <div v-if="locale == 'pt'">
          <formulario-agenda-brasil :interesse="tratamento.nome" />
        </div>
        <div v-if="locale == 'es'">
          <formulario-agenda-uruguai :interesse="tratamento.nome" />
        </div>
      </div> -->
    </div>
  </div>

  <site-tratamentos-vantagens :tratamento="slug" />

  <div class="tratamento-pesquisa-clinica">
    <site-pesquisa />
  </div>

  <site-tratamentos-tipos :tratamento="slug" />

  <site-noticias />
</template>

<script setup>
const { slug } = useRoute().params;
const { data: tratamento } = await useFetch(`/api/site/tratamentos/${slug}`);
const { t, locale } = useI18n();

useSeoMeta({
  title: `${tratamento.value.nome} - ${t("sorrifacil")}`,
  ogTitle: `${tratamento.value.nome} - ${t("sorrifacil")}`,
  description: `${tratamento.value.nome} - ${t(
    "sorrifacil"
  )} especializada em implantes e ortodontia`,
  ogDescription: `${tratamento.value.nome} - ${t(
    "sorrifacil"
  )} especializada em implantes e ortodontia`,
  ogImage: `${tratamento.value.imagem}`,
});
</script>

<script>
export default {
  name: "TratamentoPagina",
};
defineI18nRoute({
  paths: {
    pt: "/tratamentos/[slug]",
    es: "/tratamientos/[slug]",
  },
});
</script>
